import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const cartApi = createApi({
  reducerPath: 'cartApi',
  baseQuery: fetchBaseQuery({ baseUrl: '/api' }),
  tagTypes: ['Cart'],
  endpoints: builder => ({
    addCart: builder.mutation<any, { shopId: string; items: any[] }>({
      query: ({ shopId, items }) => ({
        url: '/cart',
        method: 'POST',
        body: {
          shopId,
          items,
        },
      }),
      invalidatesTags: ['Cart'],
    }),
    getCartCounting: builder.query<{ counting: number | string }, void>({
      query: () => ({
        url: '/cart/counting',
      }),
      providesTags: ['Cart'],
      keepUnusedDataFor: 60 * 60,
    }),
    getCarts: builder.query<any, void>({
      query: () => ({
        url: '/cart',
      }),
      providesTags: ['Cart'],
      keepUnusedDataFor: 60 * 60,
    }),
    deleteCartItemOptions: builder.mutation<any, string[]>({
      query: serials => ({
        url: '/cart',
        method: 'DELETE',
        body: {
          serials,
        },
      }),
      invalidatesTags: ['Cart'],
    }),
    updateCartItemOption: builder.mutation<
      any,
      { shopId: string; serial: string; count: number }
    >({
      query: ({ shopId, serial, count }) => ({
        url: '/cart',
        method: 'PUT',
        body: {
          shopId,
          serial,
          count,
        },
      }),
      invalidatesTags: ['Cart'],
    }),
    generateCart: builder.mutation<any, { shopId: string; items: any[] }>({
      query: ({ shopId, items }) => ({
        url: '/cart/generate',
        method: 'POST',
        body: {
          shopId,
          items,
        },
      }),
    }),
  }),
});

export const {
  useAddCartMutation,
  useGetCartCountingQuery,
  useGetCartsQuery,
  useDeleteCartItemOptionsMutation,
  useUpdateCartItemOptionMutation,
  useGenerateCartMutation,
} = cartApi;
